import { shuffle } from "./Utils";

export const images = {
    beyonce: require('../images/opponent/beyonce.jpg'),
    billy: require('../images/opponent/billy.jpg'),
    jay: require('../images/opponent/jay-z.jpg'),
    jeezy: require('../images/opponent/jeezy.jpg'),
    marilyn: require('../images/opponent/marilyn.jpg'),
    taylor: require('../images/opponent/taylor.jpg'),
    thomas: require('../images/opponent/thomas.jpg'),
    will: require('../images/opponent/will.jpg'),
    larry: require('../images/opponent/larry.jpg'),
    joe: require('../images/opponent/joe.jpg'),
    milton: require('../images/opponent/milton.jpg'),
    ryan: require('../images/opponent/ryan.jpg'),
    aretha: require('../images/opponent/aretha.jpg'),
};

export function getOpponents(qty: number) {
    let opponents: any[] = [];
    let names = shuffle(Object.keys(images));

    for (let i = 0; i < qty; i++) {
        const name = names[i];
        opponents.push({ name: name, image: images[name] });
    }

    return opponents;
}



// WEBPACK FOOTER //
// ./src/engine/Opponent.ts